import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Card, CardBody, Form, Input, FormGroup, Label, Button, DropdownItem, ButtonDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import TableView from '../../../Analyst/Cases/Table/index';
import Modal from '../../../components/UI/Modal/Modal';
import { setSearchCorporateParameter, selectedCorporate } from '../../../Analyst/Cases/Create/actions';
import { setKibanaConfig } from './action';
import { toast } from 'react-toastify';
import { setPageView } from '../../../components/GoogleAnalytics/index';

class DIYReportGenerate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            body: "",
            input: "",
            dropdownOpen: false,
            select: "",
            search: "",
            submitted: false,
            inputField: "",
            reportUrl: ""
        }
        this.status = "";
        this.error = "";
        this.searchCriteriaDataItems = [];
        this.searchCriteriaItems = [];
    }
    componentDidMount() {
        setPageView('/Admin/DIYReportSetup', document.location.href)
    }
    componentDidUpdate(prevProps) {
        const { saveDIYConfigSuccess, saveDIYConfigFailure, downloadKeyFailure, downloadKeySuccess } = this.props;

        if (downloadKeyFailure !== prevProps.downloadKeyFailure) {
            toast.error(
                <div>
                    <i className="fa fa-check"></i>&nbsp;{downloadKeyFailure.data.message};
                </div>
            );
        }
        if (downloadKeySuccess !== prevProps.downloadKeySuccess) {
            window.open(downloadKeySuccess);
        }
        if (saveDIYConfigSuccess !== prevProps.saveDIYConfigSuccess) {
            this.props.selectedCorporate({});
            this.setState({
                reportUrl: ""
            })
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Configurations saved successfully
                </div>
            );
        } else if (saveDIYConfigFailure !== prevProps.saveDIYConfigFailure) {
            toast.error(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Error in Saving Configurations
                </div>
            );
        }
    }
    handleSearchCorporate = (event) => {
        this.searchCriteriaDataItems = [];
        this.searchCriteriaItems = [];
        this.setState({
            submitted: false,
            select: "Name",
            isUser: false,
            searchSelected: "Corporate"
        });
        this.searchCriteriaDataItems = ["Name", "GST", "City"];
        this.searchPlaceholder = "Search Name";
        this.searchCriteriaDataItems.map((item, index) => {
            return (this.searchCriteriaItems.push(<DropdownItem onClick={this.onhandleSelected} value={item} key={index}>{item}</DropdownItem>))
        });
        this.setState({
            body: <div>
                <hr />
                <TableView selected="Corporate" />
                <Button color="primary" className="mr-1 mt-3" onClick={this.selectCorporate}>Done</Button>
                <Button color="secondary" className="mr-1 mt-3" onClick={this.handleModal}>Cancel</Button>
            </div>,
            inputField: "corporateSearch"
        })
        this.handleModal()
    }
    selectCorporate = () => {
        /* this.props.change('corporate', this.props.selectedCorp.corporateName);
        this.props.corporateResults([]) */
        this.setState({
            body: null
        })
        this.handleModal()
    }
    toggle = () => {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }))
    }
    handleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            search: ""
        }));
    }
    handleInputChange = (e) => {
        this.setState({
            search: e.target.value,
            // disabled: disabled(e.target.value),
            // [e.target.name]: e.target.value
        })

    }
    onhandleSelected = (e) => {
        this.setState({
            select: e.target.value
        });
        this.searchPlaceholder = "Search " + e.target.value;
    }
    search = (param) => {
        this.props.setSearchCorporateParameter(this.state.select, this.state.search);
    }

    handleSave = () => {
        const requestBody = {
            corporateId: this.props.selectedCorp.id,
            corporateName: this.props.selectedCorp.corporateName,
            reportUrl: this.state.reportUrl
        }
        this.props.setKibanaConfig(requestBody)
    }
    handleReportUrl = (event) => {
        this.setState({
            reportUrl: event.target.value
        })
    }
    handleKeyExtraction = () => {

    }
    render() {
        let search, dropdown;
        if (this.state.submitted === false) {
            dropdown = this.state.isUser ? "" : <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle caret>
                    {this.state.select}
                </DropdownToggle>
                <DropdownMenu>
                    {this.searchCriteriaItems}
                </DropdownMenu>
            </ButtonDropdown>;
            search = <div className='d-flex'>
                {dropdown}
                <Input type="text" name="corporateSearch" value={this.state.search} className="ml-4" id="corporate_search" placeholder={this.searchPlaceholder} onChange={this.handleInputChange} />
                <Button color="primary" className="ml-4" disabled={this.state.disabled} onClick={this.search}>
                    <i className="fa fa-search fa-fw"></i> Search
            </Button>
            </div>
        }
        return (
            <Col>
                <Card>
                    <CardBody>
                        <Form>
                            <FormGroup>
                                <Label for="exampleEmail">Corporate</Label>
                                <Input type="text" name="selectedCorporate" id="selectedCorporate" value={(this.props.selectedCorp.corporateName) ? this.props.selectedCorp.corporateName : ""} placeholder="Select Corporate" onClick={this.handleSearchCorporate} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label for="exampleEmail">Report Url</Label>
                                <Input type="text" name="reportUrl" id="reportUrl" placeholder="Paste report url here Corporate" onChange={this.handleReportUrl} value={this.state.reportUrl} />
                            </FormGroup>
                            <Button color="primary" className="mr-4" onClick={this.handleKeyExtraction}>Download Keys</Button>
                            <Button color="info" onClick={this.handleSave}>Save</Button>
                        </Form>
                    </CardBody>
                </Card>
                <Modal show={this.state.showModal} className='Large-Modal' modalClosed={this.handleModal} >
                    {search}
                    {this.state.body}
                </Modal>
            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    selectedCorp: state.createCase.selectedCorporate,
    saveDIYConfigSuccess: state.DIYReportConfig.saveDIYConfig,
    saveDIYConfigFailure: state.DIYReportConfig.saveDIYConfigFailure,
    downloadKeySuccess: state.DIYReportConfig.downloadKeySuccess,
    downloadKeyFailure: state.DIYReportConfig.downloadKeyFailure
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    setSearchCorporateParameter: (param, search) => { dispatch(setSearchCorporateParameter(param, search)); },
    setKibanaConfig: (data) => { dispatch(setKibanaConfig(data)) },
    selectedCorporate: (corp) => { dispatch(selectedCorporate(corp)); },//
});


export default DIYReportGenerate = connect(
    mapStateToProps,
    mapDispatchToProps
)(DIYReportGenerate)